import { SportTerminology, SportTermLookup } from '../types';
import { pluralTerm } from './term.helper';

// Human label for an assessment-stage type, using the company's sport terminology.
// Shared by the stage builder and the format-template preview so the two never drift.
export const getStageTypeLabel = (type: string, termLookup: SportTermLookup): string => {
  const athletes = pluralTerm(termLookup[SportTerminology.ATHLETE]);
  switch (type) {
    case 'GROUP':
      return `Group ${athletes}`;
    case 'ROUTE':
      return `Route ${athletes}`;
    case 'SESSION':
      return termLookup[SportTerminology.SESSION];
    default:
      return type;
  }
};
